import React, { useLayoutEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Text clamped to `lines` lines with a Show more / Show less toggle.
 * The toggle only appears when the text actually overflows, which is measured after
 * layout (and again on resize) instead of guessed from the character count.
 */
export default function ExpandableText({ text, lines = 3, className = '', as: Tag = 'p' }) {
    const { t } = useTranslation()
    const ref = useRef(null)
    const [expanded, setExpanded] = useState(false)
    const [overflowing, setOverflowing] = useState(false)

    useLayoutEffect(() => {
        const element = ref.current
        if (!element || expanded) return undefined
        const measure = () => setOverflowing(element.scrollHeight - element.clientHeight > 1)
        measure()
        if (typeof ResizeObserver === 'undefined') return undefined
        const observer = new ResizeObserver(measure)
        observer.observe(element)
        return () => observer.disconnect()
    }, [text, lines, expanded])

    if (!text) return null

    return (
        <div className="archive-expandable">
            <Tag ref={ref} className={`${className} ${expanded ? '' : 'archive-clamp'}`} style={expanded ? undefined : { WebkitLineClamp: lines }}>
                {text}
            </Tag>
            {(overflowing || expanded) && (
                <button type="button" className="archive-text-toggle" aria-expanded={expanded} onClick={() => setExpanded((value) => !value)}>
                    {expanded ? t('showLess') : t('showMore')}
                </button>
            )}
        </div>
    )
}
